import dayjs from 'dayjs';
import { dayjsLocal } from '../dayjs-local';

export const DateTransform = {
  // Transform từ string sang dayjs khi receive từ API
  toClass: ({ value }: any) => {
    if (!value) return undefined;
    const d = dayjsLocal(value);
    return d.isValid() ? d : undefined;
  },

  // Transform từ dayjs sang string khi send tới API
  toPlain: ({ value }: any) => {
    if (!value) return undefined;
    const d = dayjs.isDayjs(value) ? value : dayjsLocal(value);
    return d.isValid() ? d.format('YYYY-MM-DDTHH:mm:ss') : undefined;
  }
};
